module.exports = __webpack_public_path__ + "static/media/video-placeholder.b4a0cd02.jpg";